import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, ConfigProvider } from 'antd';
import SideMenu, { NavigationProvider } from '../../components/side-menu/side-menu';
import Loader from '../../components/loader/loader';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Header from './../../components/header/header';
import Footer from './../../components/footer/footer';
import ReqiuredAuthComponent from './../../components/auth-guard/auth-guard';
import '../../App.css';

const LoginContainer = lazy(() => import('../admin-login/admin-login'));
const LabsContainer = ReqiuredAuthComponent(lazy(() => import('../labs/labs-container')));
const TestsContainer = ReqiuredAuthComponent(lazy(() => import('../tests/tests-container')));
const CategoriesContainer = ReqiuredAuthComponent(lazy(() => import('../analysis-categories/analysis-categories-container')));
const AnalyticsContainer = ReqiuredAuthComponent(lazy(() => import('../analytics/analytics')));
const MapDashboardContainer = ReqiuredAuthComponent(lazy(() => import('../map-dashboard/map-dashboard-container')));
const UsersContainer = ReqiuredAuthComponent(lazy(() => import('../users/users-container')));
const PaymentsContainer = ReqiuredAuthComponent(lazy(() => import('../payments/payments-container')));
const InquiriesContainer = ReqiuredAuthComponent(lazy(() => import('../inquiries/inquiries-container')));
const ScoreboardContainer = ReqiuredAuthComponent(lazy(() => import('../scoreboard/scoreboard-container')));
const CompanyDashboard = ReqiuredAuthComponent(lazy(() => import('../../components/users/company-dashboard')));
const CocTypesContainer = ReqiuredAuthComponent(lazy(() => import('../coc-types/coc-types-container')));

// const LoginContainer = MyLoadableComponent({
//     loader: () => import('./../admin-login/admin-login')
// });


// const LabsContainer = MyLoadableComponent({
//     loader: () => import('./../labs/labs-container')
// });

// const TestsContainer = MyLoadableComponent({
//     loader: () => import('./../tests/tests-container')
// });

// const CategoriesContainer = MyLoadableComponent({
//     loader: () => import('./../analysis-categories/analysis-categories-container')
// });

const PageLoading = ({ authenticated }) => authenticated
    ? <div className="slim-body"><SideMenu /><main className="slim-mainpanel"><Loader inline label="Opening page…" /></main></div>
    : <Loader inline label="Opening sign in…" />;

class PageBoundary extends React.Component {
    state = { error: false };
    static getDerivedStateFromError() { return { error: true }; }
    componentDidUpdate(previous) {
        if (this.state.error && previous.location.pathname !== this.props.location.pathname) this.setState({ error: false });
    }
    render() {
        return this.state.error ? <div className="slim-body">
            {this.props.authenticated && <SideMenu />}
            <main className="slim-mainpanel"><div className="map-load-error"><Alert type="error" showIcon message="Unable to open this page" description="Please check your connection and reload. You can also choose another page from the navigation." action={<Button onClick={() => window.location.reload()}>Reload</Button>} /></div></main>
        </div> : this.props.children;
    }
}
const RouteBoundary = withRouter(PageBoundary);

const App = (props) => {
    return (
        <ConfigProvider theme={{ token: { colorPrimary: '#1677ff', borderRadius: 8, colorBorder: '#dce3ed', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" } }}>
            <NavigationProvider>
                <Router>
                    <React.Fragment>
                        {props.isAdminLogin ? <Header /> : null}
                        <RouteBoundary authenticated={props.isAdminLogin}>
                            <Suspense fallback={<PageLoading authenticated={props.isAdminLogin} />}>
                                <Switch>
                                    <Route exact path='/' render={() => <Redirect to={props.isAdminLogin ? '/analytics' : '/login'} />} />
                                    <Route exact path='/login' component={LoginContainer} />
                                    <Route path='/labs' component={LabsContainer} />
                                    <Route exact path='/tests' component={TestsContainer} />
                                    <Route exact path='/categories' component={CategoriesContainer} />
                                    <Route exact path='/analytics' component={AnalyticsContainer} />
                                    <Route path='/map-dashboard' component={MapDashboardContainer} />
                                    <Route path='/companies/:companyId?' component={CompanyDashboard} />
                                    <Route path='/users' component={UsersContainer} />
                                    <Route exact path='/payments' component={PaymentsContainer} />
                                    <Route exact path='/inquiries' component={InquiriesContainer} />
                                    <Route exact path='/scoreboard' component={ScoreboardContainer} />
                                    <Route exact path='/coc-types' component={CocTypesContainer} />
                                    <Redirect from="**" to="/login" />
                                    <Route path='**' component={LoginContainer} />
                                </Switch>
                            </Suspense>
                        </RouteBoundary>
                    </React.Fragment>
                </Router>
                {props.isAdminLogin ? <Footer /> : null}
            </NavigationProvider>
        </ConfigProvider>
    );
}

App.defaultProps = {
    isAdminLogin: false,
}

App.propTypes = {
    isAdminLogin: PropTypes.bool,
}

const mapStateToProps = (state) => {

    return {
        isAdminLogin: state.adminProfile.isAdminLogin
    }
}

export default connect(mapStateToProps, null)(App);
